import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuthWithoutBody,
  headersWithAuth,
  decryptResponse,
} from "../../../APIHelpers/Responses";

export const bookmarkTeamProjectServices = {
  bookmarkManageTeamProject,
  getBookmarkTeamProjectList
};

// Bookmark Manage Team Project
async function bookmarkManageTeamProject(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}bookmarkManageTeamProject`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Get Bookmark Team Project
async function getBookmarkTeamProjectList() {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getBookmarkTeamProjectList`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}